import React from 'react'
import {BsInstagram,BsLinkedin} from 'react-icons/bs'
import {FaFacebook} from 'react-icons/fa'
const SocialMedia = () => {
  return (
    <div className="app__social">
      <div >
        <a href="https://www.instagram.com/harshjain.2004/?hl=en">
        <BsInstagram  />
        </a>
        </div>

      <div>
        <a href="https://www.linkedin.com/in/harshjain2004/">
        <BsLinkedin/>
        </a>
        </div>

      <div>
        <a href="https://www.facebook.com/profile.php?id=100092276293485">
        <FaFacebook/>

        </a>
        </div>
    </div>
  )
}

export default SocialMedia
